module.exports = __webpack_public_path__ + "static/media/top1.fb965a37.svg";